import { useSyncExternalStore } from 'react';

const noopSubscribe = () => () => {};

/**
 * `false` during server rendering and during the hydration render, `true`
 * from then on. In a client-rendered app (the portal) it is `true` on the
 * first render, so it changes nothing there.
 *
 * Use it for UI that depends on browser-only state and must not be baked into
 * prerendered HTML (Slice 1C, architect ruling AR-P2 / AR-P7). Never branch on
 * `typeof window` in render instead: that is the classic hydration-mismatch
 * cause, and React 19 keeps the server's attributes when they disagree.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    noopSubscribe,
    () => true,
    () => false,
  );
}
